import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=44bacdd4&scoped=true&"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&id=44bacdd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bacdd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bacdd4')) {
      api.createRecord('44bacdd4', component.options)
    } else {
      api.reload('44bacdd4', component.options)
    }
    module.hot.accept("./HorizontalScroll.vue?vue&type=template&id=44bacdd4&scoped=true&", function () {
      api.rerender('44bacdd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/ScrollBars/HorizontalScroll.vue"
export default component.exports